module.exports = __webpack_public_path__ + "img/credit-cards.c92138a0.png";